import styled from 'styled-components';
import SplashBackground from '@assets/images/SplashscreenBackground.png';
import { INTER } from '@styles/fonts';

export const SplashContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  background-image: url(${SplashBackground});
  background-size: cover;
  background-position: center;
`;

export const Website = styled.span`
  color: white;
  font-family: ${INTER.semiBold};
  font-size: 20px;
  font-weight: 600;
`